export enum TaskStatuses {
  Unclaimed = 'unclaimed',
  Claimed = 'claimed',
  InProgress = 'inProgress',
  Completed = 'completed',
  Cancelled = 'cancelled',
  OnHold = 'onHold',
  Expired = 'expired',
}
